import { useAtomValue } from 'jotai';
import { useTranslation } from '@wojtekmaj/react-t';

import { Link, Wrapper } from './header.styles';

import Avatar from '../../common/avatar';
import RewardoLogo from '../../common/rewardo_logo';

import { currentUserState } from '../../../store';

export default function Header() {
  const currentUser = useAtomValue(currentUserState);
  const profileString = useTranslation('Profile');

  return (
    <Wrapper>
      <RewardoLogo />
      <Link aria-label={profileString} to="/profile">
        <Avatar user={currentUser} size={40} />
      </Link>
    </Wrapper>
  );
}
